import React from "react";
import { Link } from "react-router-dom";
import {
  DocumentTextIcon,
  ShieldCheckIcon,
  DocumentCheckIcon,
} from "@heroicons/react/24/outline";
import topicsBackground from "../assets/images/topics_background.svg";

const LegalPage: React.FC = () => {
  return (
    <div className="min-h-screen relative pb-6 bg-gradient-to-b from-electrum-100 via-white to-white">
      {/* Fixed Background Image */}
      <div
        className="fixed inset-0 z-0 top-8"
        style={{
          backgroundImage: `url(${topicsBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-8 py-8 my-10 bg-white shadow-lg rounded-lg">
        <h1 className="text-3xl font-bold mb-6 text-gray-900">
          Legal and Privacy Policy
        </h1>
        <div className="space-y-6">
          <Link
            to="/terms-of-service"
            className="flex items-center space-x-4 p-4 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-colors"
          >
            <DocumentTextIcon className="w-8 h-8 text-blue-600 flex-shrink-0" />
            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                Terms of Service
              </h2>
              <p className="text-sm text-gray-600 mt-1">
                Read our terms and conditions
              </p>
            </div>
          </Link>

          <Link
            to="/privacy-policy"
            className="flex items-center space-x-4 p-4 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-colors"
          >
            <ShieldCheckIcon className="w-8 h-8 text-blue-600 flex-shrink-0" />
            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                Privacy Policy
              </h2>
              <p className="text-sm text-gray-600 mt-1">
                Learn how we protect your privacy
              </p>
            </div>
          </Link>

          <Link
            to="/end-user-license-agreement"
            className="flex items-center space-x-4 p-4 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-colors"
          >
            <DocumentCheckIcon className="w-8 h-8 text-blue-600 flex-shrink-0" />
            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                End User License Agreement
              </h2>
              <p className="text-sm text-gray-600 mt-1">
                Review the license agreement
              </p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
